import type { PropsWithChildren } from 'react';

import { type UploadCommonProps } from '../../Upload'
import { SubText } from '@ui/elements/Text'

export interface IUploadTextProps {
  commonProps: UploadCommonProps
  innerProps: {
    maxFileSize: string
  }
}

export const UploadText = ({
  commonProps,
}: PropsWithChildren<IUploadTextProps>) => {
  const { strings } = commonProps

  return <SubText>{strings?.uploadInfo}</SubText>
}
